export default __webpack_public_path__ + "static/aaron-178beaf44f925e5ce90d67e79a5e6971.jpg";